// extracted by mini-css-extract-plugin
export var info = "info-module--info--3a617";
export var infoDark = "info-module--info--dark--a2814";
export var infoEmpty = "info-module--info--empty--7a21d";
export var mt0 = "info-module--mt-0--63b5c";
export var mt1 = "info-module--mt-1--5200f";
export var mt2 = "info-module--mt-2--c313f";
export var mt3 = "info-module--mt-3--b3820";
export var mt4 = "info-module--mt-4--5287a";
export var mt5 = "info-module--mt-5--c71e6";
export var mt6 = "info-module--mt-6--7233a";